export const QUERY_IDS = {
  WHO_AM_I: 'whoami',
  GET_COMMUNICATIONS: 'getCommunications',
  GET_OPPORTUNITIES: 'getOpportunities',
  GET_SMS_CAMPAIGNS: 'getSmsCampaigns',
}
